import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abreviate'
})
export class AbreviatePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.replace(/[^0-9a-z]/gi, '').substring(0, 2);

  }

}
